// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background: #fff;
  border-top: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding: 5px 15px;
  white-space: nowrap;
}

img {
  height: 14px;
  margin-left: 5px;
}

div {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/dms/etax-shared/powered-by/powered-by.component.scss"],"names":[],"mappings":"AAAA;EACG,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AACH;;AAEA;EACG,YAAA;EACA,gBAAA;AACH;;AAEA;EACG,aAAA;EACA,mBAAA;AACH","sourcesContent":[":host {\n   background: #fff;\n   border-top: 1px solid #e5e5e5;\n   display: flex;\n   align-items: center;\n   justify-content: space-between;\n   font-size: 12px;\n   padding: 5px 15px;\n   white-space: nowrap;\n}\n\nimg {\n   height: 14px;\n   margin-left: 5px;\n}\n\ndiv {\n   display: flex;\n   align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
